export default __webpack_public_path__ + "static/media/sister.24444e3d.ogg";